import { render, staticRenderFns } from "./FufuHeader.vue?vue&type=template&id=03d25860&"
import script from "./FufuHeader.vue?vue&type=script&lang=js&"
export * from "./FufuHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports